import { createAsyncThunk } from '@reduxjs/toolkit';
import userManagementApi from '~/apis/userManagement';
import {
  IParamsGetUsers,
  IResponseGetUsers,
  ICreateUserPayload,
  IUpdateUserPayload,
  IDeleteUserPayload,
} from '~/apis/userManagement';

// Action types
export const GET_USERS = 'userManagement/getUsers';
export const GET_USER = 'userManagement/getUser';
export const CREATE_USER = 'userManagement/createUser';
export const UPDATE_USER = 'userManagement/updateUser';
export const DELETE_USERS = 'userManagement/deleteUsers';

export const handleGetUsers = createAsyncThunk<IResponseGetUsers, IParamsGetUsers | undefined>(
  GET_USERS,
  async (params, { rejectWithValue }) => {
    try {
      const res = await userManagementApi.getUsers(params);
      return res.data.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error?.response?.data?.message || error?.message || 'Failed to fetch users'
      });
    }
  }
);

export const handleCreateUser = createAsyncThunk<unknown, ICreateUserPayload>(
  CREATE_USER,
  async (payload, { rejectWithValue }) => {
    try {
      const res = await userManagementApi.createUser(payload);
      return res.data.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error?.response?.data?.message || error?.message || 'Failed to create user'
      });
    }
  }
);

export const handleUpdateUser = createAsyncThunk<unknown, { id: string; payload: IUpdateUserPayload }>(
  UPDATE_USER,
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const res = await userManagementApi.updateUser(id, payload);
      return res.data.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error?.response?.data?.message || error?.message || 'Failed to update user'
      });
    }
  }
);

export const handleDeleteUsers = createAsyncThunk<unknown, IDeleteUserPayload>(
  DELETE_USERS,
  async (payload, { rejectWithValue }) => {
    try {
      const res = await userManagementApi.deleteUsers(payload);
      return res.data.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error?.response?.data?.message || error?.message || 'Failed to delete user'
      });
    }
  }
);
